<template>
  <div :class="['pt-10 pb-5 component-div', isRTLlang(lang) ? 'rtl mrgn-rt-25' : '', isFieldDisabled ? 'disable-question' : '']">
    <b-row>
      <div class="d-flex pl-14 col-8">
        <b-col cols="0" :class="{ 'pl-0': displayMobileView }" v-if="isDisplayQuestionInfo">
          <div class="number-sequence">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
        </b-col>
        <b-col :md="`pl-10 p-0 ${isRTLlang(lang) ? 'rtl' : 12}`" :sm="`${isRTLlang(lang) ? 'rtl' : '12'}`" :class="['text_format_align',isRTLlang(lang) ? '' : 'screen-title']" v-if="isDisplayQuestionInfo">
          <span
            v-translate:_formattedTitle="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedTitle
            }"
            v-html="componentData.formattedTitle"
          ></span>
        </b-col>
      </div>
    </b-row>
    <b-row class="pl-15 pt-0" v-if="isDisplayQuestionInfo && displayMobileView === false">
      <b-col cols="8" class="col_text_padding">
        <div class="activity-form__question-container">
          <div class="pl-30 text-center">
            <div v-if="componentData.previewImageUrl" class="imageBox">
              <img class="img-size" :src="componentData.previewImageUrl" />
            </div>
            <div
              :class="['instruction_info mt-5 pt-5', isRTLlang(lang) ? 'rtl text-right' : 'text-left']"
              v-translate:_formattedInformation="{
                key: translationKeyInitial,
                val: lang,
                html: componentData.formattedInformation
              }"
              v-html="componentData.formattedInformation"
            ></div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="pl-30" v-if="isDisplayQuestionInfo && displayMobileView === true">
      <b-col class="text_format_align">
        <div class="activity-form__question-container">
          <div class="text-center">
            <div v-if="componentData.previewImageUrl" class="imageBox">
              <img class="img-size" :src="componentData.previewImageUrl" width="275px" />
            </div>
            <div
              :class="['instruction_info mt-5 pt-5', isRTLlang(lang) ? 'rtl text-right' : 'text-left']"
              ref="instruction-form-preview-mobile"
              v-translate:_formattedInformation="{
                key: translationKeyInitial,
                val: lang,
                html: componentData.formattedInformation
              }"
              v-html="componentData.formattedInformation"
            ></div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import * as constant from "../../../constants/config";
import langTranslate from "./lang-translate";
import { loadData } from "@/services/video-render";

export default {
  name: "activity-form-instruction-step-preview",

  mixins: [langTranslate],

  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      displayMobileView: Boolean
    };
  },
  mounted() {
    if (this.displayMobileView == false) {
      loadData(this.$refs["instruction-form-preview"]);
    } else {
      loadData(this.$refs["instruction-form-preview-mobile"]);
    }
  },
  watch: {
    componentData: {
      handler() {
        this.$nextTick(() => {
          if (this.displayMobileView == false) {
            loadData(this.$refs["instruction-form-preview"]);
          } else {
            loadData(this.$refs["instruction-form-preview-mobile"]);
          }
        });
      }
    }
  },
  created() {
    if (this.mode == 1) {
      this.$emit("initAnswerChange", this.componentData);
    }
    if (constant.SCREENWIDTH > 1200) {
      this.displayMobileView = false;
    } else {
      this.displayMobileView = true;
    }
  },
  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      type: Boolean,
      default: false
    },
    mode: {
      default: 0
    },
    activityInfo: {
      default: () => {}
    }
  },

  methods: {
    isRTLlang(lang) {
      return lang == "he" || lang == "ar-IL";
    },
    clearAnswer() {
      this.componentData.answer = undefined;
      this.$emit("onClearAnswer", this.componentData);
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.$emit("onAnswerChange", this.componentData);
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.number-sequence {
  min-width: 30px;
  display: inline-block;
}
.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}
.screen-title {
    margin-left: 10px;
    margin-bottom: 10px;
  }
.cursor_pointer1 {
  cursor: pointer;
  width: 22px;
  height: 20px;
  border-radius: 4px;
  background-color: #c4c4c4;
  display: inline-block;
  color: #fff;
  text-align: center;
}
/deep/ p {
  margin-bottom: 0rem !important;
}
.col_text_padding {
  padding: 0px !important;
}
.text_format_align {
  position: relative;
  right: 9px !important;
}
.imageBox {
  text-align: left;

  .img-size {
    height: auto;
  }
}
@media (min-width: 320px) and (max-width: 768px) {
  .number-sequence[data-v-238a48b8] {
    max-width: 30px;
    display: inline-block;
  }
}
.img-size {
  width: 100%;
}
/deep/ strong {
  font-weight: bolder !important;
  font-family: "RobotoBold" !important;
}
</style>
